export const delayFn = (refetch: Function, ms: number = 1500) => {
  setTimeout(() => {
    refetch()
  }, ms)
  clearTimeout()
}
